import { Link } from "react-router-dom";

export default function ShippingPage() {
  return (
    <div className="min-h-screen bg-cotton-100 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-heading text-4xl font-bold text-primary mb-8">
          Shipping & Delivery Policy
        </h1>
        
        <div className="bg-white p-8 rounded-lg shadow-soft space-y-6">
          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">Shipping Coverage</h2>
            <p className="text-muted-foreground leading-relaxed">
              OGAS ships to all locations across India. We currently do not offer international shipping.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">Shipping Charges</h2>
            <p className="text-muted-foreground leading-relaxed">
              <strong>FREE SHIPPING</strong> on all orders across India! No minimum order value required.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">Delivery Time</h2>
            <table className="w-full text-muted-foreground">
              <thead>
                <tr className="border-b">
                  <th className="py-2 text-left font-medium">Region</th>
                  <th className="py-2 text-left font-medium">Estimated Delivery</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b">
                  <td className="py-2">Tamil Nadu</td>
                  <td className="py-2">2-3 business days</td>
                </tr>
                <tr className="border-b">
                  <td className="py-2">South India (Kerala, Karnataka, Andhra Pradesh, Telangana)</td>
                  <td className="py-2">3-5 business days</td>
                </tr>
                <tr className="border-b">
                  <td className="py-2">Rest of India</td>
                  <td className="py-2">5-7 business days</td>
                </tr>
                <tr>
                  <td className="py-2">Remote/Rural Areas</td>
                  <td className="py-2">7-10 business days</td>
                </tr>
              </tbody>
            </table>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">Order Tracking</h2>
            <p className="text-muted-foreground leading-relaxed">
              Once your order is dispatched, you will receive a tracking number via email and SMS. 
              You can also track your order by logging into your account on our website.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">Order Processing</h2>
            <p className="text-muted-foreground leading-relaxed">
              Orders are processed within 1-2 business days. Orders placed on weekends or holidays 
              will be processed on the next business day.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">Contact for Shipping Queries</h2>
            <p className="text-muted-foreground leading-relaxed">
              For shipping-related queries, contact us at:<br />
              <strong>Email:</strong> admin@ogas.in<br />
              <strong>Phone:</strong> +91 99947 93643<br />
              <strong>WhatsApp:</strong> +91 99947 93643
            </p>
          </section>
        </div>

        <div className="mt-8 text-center">
          <Link to="/" className="text-primary hover:underline">← Back to Home</Link>
        </div>
      </div>
    </div>
  );
}
